/**
 * Mobile Close Control for Mapbox
 * Replaces zoom controls on mobile with a close/cross icon
 * Clicking it collapses the map (sets showMap = false)
 */

class MobileCloseControl {
    constructor(options = {}) {
        this._onClose = options.onClose || null;
        this._map = null;
        this._btn = null;
        this._containerElement = null;
    }

    onAdd(map) {
        this._map = map;

        // Create button element with cross icon
        this._btn = document.createElement('button');
        this._btn.className = 'mapboxgl-ctrl-icon mapboxgl-ctrl-close-mobile';
        this._btn.type = 'button';
        this._btn.setAttribute('aria-label', 'Close map');
        this._btn.setAttribute('title', 'Close map');
        this._btn.onclick = () => {
            if (this._onClose) {
                this._onClose();
            }
        };

        // Create container for the control
        this._containerElement = document.createElement('div');
        this._containerElement.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
        this._containerElement.appendChild(this._btn);

        return this._containerElement;
    }

    onRemove() {
        if (this._containerElement && this._containerElement.parentNode) {
            this._containerElement.parentNode.removeChild(this._containerElement);
        }
        this._map = null;
        this._btn = null;
        this._containerElement = null;
    }

    getDefaultPosition() {
        return 'top-right';
    }
}

export default MobileCloseControl;

